import { render, staticRenderFns } from "./AdminDropped2022List.vue?vue&type=template&id=218ea914&scoped=true"
import script from "./AdminDropped2022List.vue?vue&type=script&lang=js"
export * from "./AdminDropped2022List.vue?vue&type=script&lang=js"
import style0 from "./AdminDropped2022List.vue?vue&type=style&index=0&id=218ea914&prod&lang=scss&scoped=true"
import style1 from "./AdminDropped2022List.vue?vue&type=style&index=1&id=218ea914&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "218ea914",
  null
  
)

export default component.exports